import { render, staticRenderFns } from "./DetalleEvento.vue?vue&type=template&id=25e06f09&scoped=true"
import script from "./DetalleEvento.vue?vue&type=script&lang=js"
export * from "./DetalleEvento.vue?vue&type=script&lang=js"
import style0 from "./DetalleEvento.vue?vue&type=style&index=0&id=25e06f09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e06f09",
  null
  
)

export default component.exports